@let m = message();
@let info = payload();
@if (info) {
  @let shared = file();
  @let gone = !shared && filesService.loaded();
  @let busy = !!shared && filesService.downloading().has(shared.id);
  <div class="file-card-row">
    <div class="file-card" [class.file-card--gone]="gone">
      <fa-duotone-icon class="file-card__icon" [icon]="icon()"></fa-duotone-icon>
      <div class="file-card__meta">
        <span class="file-card__by">{{ headline() }} · {{ m.time | relativeTime: lang() }}</span>
        <span class="file-card__name" [title]="info.name">
          {{ info.name }}
          @if (info.encrypted) {
            <fa-duotone-icon
              class="file-card__lock"
              [icon]="faLock"
              [title]="'Encrypted' | translate"></fa-duotone-icon>
          }
        </span>
        <span class="file-card__sub">
          {{ gone ? ('No longer available' | translate) : formatBytes(info.size, 1) }}
        </span>
        @if (shared && downloads.isUnlocking(shared)) {
          <div class="file-card__unlock">
            <input
              class="file-card__input"
              type="password"
              autocomplete="off"
              [placeholder]="'File password' | translate"
              [attr.aria-label]="'File password' | translate"
              [class.file-card__input--error]="downloads.unlocking()?.wrong"
              [value]="downloads.password()"
              (input)="downloads.setPassword($event)"
              (keydown.enter)="downloads.submit(shared)"
              (keydown.escape)="downloads.cancel()" />
            <andor-button density="compact" (click)="downloads.submit(shared)">
              {{ 'Open' | translate }}
            </andor-button>
          </div>
          @if (downloads.unlocking()?.wrong) {
            <span class="file-card__error">{{ 'Wrong password.' | translate }}</span>
          }
        }
      </div>
      @if (shared) {
        <andor-square-icon-btn
          class="file-card__download"
          [disabled]="busy"
          [tooltip]="'Download' | translate"
          [ariaLabel]="'Download' | translate"
          (clicked)="downloads.download(shared)">
          <fa-duotone-icon
            [class.file-card__spinner]="busy"
            [icon]="busy ? faSpinnerThird : faDownload"></fa-duotone-icon>
        </andor-square-icon-btn>
      }
    </div>
  </div>
}
